export const IS_DEV_MODE = process.env.NODE_ENV === 'development';

export const CHAT_CONFIG = {
  enhancedChatBaseUrl: process.env.REACT_APP_ENHANCED_CHAT_API_URL,
  chatBotHost: IS_DEV_MODE
    ? process.env.REACT_APP_CHATBOT_URL
    : `${process.env.REACT_APP_FMP_APIS_URL || ''}`.replace('/v1', ''),
  chatProxyHost: process.env.REACT_APP_SALESFORCE,
  botAvailable: true,
  advisorAvailable: true,
  isSalesforceCaseRequired: false,
  serviceWindow: {
    openTime: '08:00',
    closeTime: '17:00',
  },
  businessUnit: 1,
  client: process.env.REACT_APP_DPD_CLIENT,
  additionalDetails: {
    platform: 'FMP',
    reason: 'FMP - Find My Parcel',
  },
  googleMapsApiKey: process.env.REACT_APP_STATIC_GOOGLE_MAP_API_KEY,
};
